module.exports = __webpack_public_path__ + "static/media/pickup-car-icon.d511cdc6.svg";